import React from 'react';
import {MasterLayout} from 'components/layouts';
import {SigninForm} from 'components/signin';
import title from 'constants/TitlePages.js';

class Register extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.signin;
  }

  render() {
    return (
      <MasterLayout>
        <SigninForm/>
      </MasterLayout>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./pages/Signin.jsx